// extracted by mini-css-extract-plugin
export var barContainer = "_4r-0";
export var extraThin = "_4r-3";
export var fillBar = "_4r-6";
export var fillContainer = "_4r-4";
export var overflow = "_4r-8";
export var overflowContainer = "_4r-5";
export var regular = "_4r-7";
export var thick = "_4r-1";
export var thin = "_4r-2";